import TouchDropdownToggle from "./touch-dropdown-toggle";
import MobileNav from "./mobile-nav";

const HeaderNav = {

  init() {
    MobileNav.init();
    TouchDropdownToggle.init();
  },
};

export default HeaderNav;